export default __webpack_public_path__ + "static/media/deleteattachment.c7af6fd7.svg";